import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from '../../Icon';

const EmptyContent = ({
  icon,
  size = 148,
  text,
  iconFill,
  className,
  ...other
}) => (
  <div className={cn('tc', className)} {...other}>
    <Icon name={icon} size={size} className="pb4" style={{ fill: iconFill }} />
    <p className="ttu">{text}</p>
  </div>
);

EmptyContent.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.number,
  text: PropTypes.string,
  iconFill: PropTypes.string,
  className: PropTypes.string,
};

export default EmptyContent;



// WEBPACK FOOTER //
// ./src/components/common/EmptyState/Content.jsx